<h2 mat-dialog-title>Modifica descrizione</h2>

<mat-dialog-content>
  <p class="mb-3">
    Aggiorna il testo di supporto per <strong>{{ data?.step?.nome }}</strong>. Il
    contenuto verrà mostrato come tooltip agli utenti.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Descrizione</mat-label>
      <textarea matInput rows="6" formControlName="descrizione"></textarea>
      <mat-hint align="end">
        {{ form.get('descrizione')?.value?.length || 0 }}/5000
      </mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annulla</button>
  <button mat-stroked-button color="primary" (click)="save()">Salva</button>
</mat-dialog-actions>

